import { render } from "./PdpProductImageZoom.vue?vue&type=template&id=1e922c72&scoped=true"
import script from "./PdpProductImageZoom.vue?vue&type=script&lang=js"
export * from "./PdpProductImageZoom.vue?vue&type=script&lang=js"

import "./PdpProductImageZoom.vue?vue&type=style&index=0&id=1e922c72&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e922c72"]])

export default __exports__